export const config = {
  apiKey:
    "3500F0ED-D312-4B41-8860-547F63DDE11CE05353BF-83CC-4D58-BFCD-7FF361A0EC5A",
};
